export enum PressableType {
  Default = 'Default',
  GestureHandler = 'GestureHandler',
}
